if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"ocelot","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2820|3019|3110|5098|532)$/.test(chunkId)},
		rootOutputDir: "../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}